import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type MigrationRequestNotFoundErrorOptions = {
  migrationRequest: ObjectId;
};

export class MigrationRequestNotFoundError extends FleekError<MigrationRequestNotFoundErrorOptions> {
  public name = 'MigrationRequestNotFoundError';

  toString = () => `Migration request ${this.data.migrationRequest.id} not found.`;
}
